<template>
<div class="chapter">
<div class="inner_page">
<div class="figcenter">
<img alt="The Fight with the Puma." height="450" src="Images/001.jpg" title="" width="319"/>
<p>The Fight with the Puma.—<a class="c1 pginternal" href="#/Text/main1.htm#Page_59">Page 59.</a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// main_0001.vue?2c55901d